export var AlloyType;
(function (AlloyType) {
    AlloyType["Atom"] = "atom";
    AlloyType["Field"] = "field";
    AlloyType["Signature"] = "signature";
    AlloyType["Skolem"] = "skolem";
    AlloyType["Tuple"] = "tuple";
})(AlloyType || (AlloyType = {}));
